import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@wh/svg-icons/ArrowRight';

import './link.scss';

const Link = props => (
    <a styleName={`link ${props.deviceType}`} href={props.data.url} target={props.data.target}>
        {props.data.link}
        <ArrowRight styleName="arrow" />
    </a>
);

Link.propTypes = {
    data: PropTypes.shape({
        link: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
    }).isRequired,
    deviceType: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
};

export default Link;
